import isOptionsListValid from './validation/option-list';
const DEFAULT_OPTIONS_LIST = [{ id: 1, title: '', weight: 0 }];
export default function parseOptionsList(storedData, callback) {
    let parsed;
    try {
        parsed = storedData === null ? undefined : JSON.parse(storedData);
    }
    catch {
        parsed = undefined;
    }
    if (parsed && isOptionsListValid(parsed)) {
        return parsed;
    }
    else {
        if (callback)
            callback(DEFAULT_OPTIONS_LIST);
        return DEFAULT_OPTIONS_LIST;
    }
}
